import { render, staticRenderFns } from "./SERPTypesCell.vue?vue&type=template&id=2eb86e56&scoped=true&"
import script from "./SERPTypesCell.vue?vue&type=script&lang=js&"
export * from "./SERPTypesCell.vue?vue&type=script&lang=js&"
import style0 from "./SERPTypesCell.vue?vue&type=style&index=0&id=2eb86e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb86e56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
